export let hres6keColumns = () => {
  let indexColumns = [
    {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES6KEC1',
      labelIndex: '10',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'numseq',
      name: '',
      labelCodapp: 'HRES6KEC1',
      labelIndex: '20',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'numotreq',
      name: '',
      labelCodapp: 'HRES6KEC1',
      labelIndex: '30',
      style: 'min-width: 150px;'
    }, {
      key: 'dterange',
      name: '',
      labelCodapp: 'HRES6KEC1',
      labelIndex: '40',
      class: 'align-center',
      style: 'min-width: 200px;',
      dataType: 'dateRange'
    }, {
      key: 'desc_stareq',
      name: '',
      labelCodapp: 'HRES6KEC1',
      labelIndex: '50',
      style: 'min-width: 200px;'
    }, {
      key: 'remarkap',
      name: '',
      labelCodapp: 'HRES6KEC1',
      labelIndex: '60',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRES6KEC1',
      labelIndex: '70',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRES6KEC1',
      labelIndex: '80',
      style: 'min-width: 200px;'
    }
  ]

  return {
    en: {
      index: indexColumns
    },
    th: {
      index: indexColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres6ke.js